import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Permission, Res } from 'core/api';
import * as SalesStore from '../SalesStore';
import { Command } from 'pos/common';
import { Message } from 'core/ui-next/modal';


declare global {
	interface CommandType {
		prepareCurrentTicketAgain: () => Promise<Result>,
		prepareMultipleTicketsAgain: (ticketIds: number[]) => Promise<Result>
	}
}

Command.register('prepareCurrentTicketAgain', Preconditions.ensure(Permission.Ticket_PrepareTicketAgain), async (): Promise<Result> => {
	const ticket = SalesStore.getTicket();
	if (ticket.IsEmpty) {
		await Message.show(Res.Msg.MSG_TICKET_IS_EMPTY());
		return Result.error();
	}

	return prepareTicketsAgain([ticket.Id]);
});

Command.register('prepareMultipleTicketsAgain', Preconditions.ensure(Permission.Ticket_PrepareTicketAgain), async (ticketIds: number[]): Promise<Result> => {
	return prepareTicketsAgain(ticketIds);
});


async function prepareTicketsAgain(ticketIds: number[]): Promise<Result> {
	await SalesStore.prepareAgain(ticketIds);
	return Result.ok();
}
